import { PaymentBraintreeStoreRequest } from '@models/requests/payment-braintree-store-request.model';

export class PaymentRechargeBraintreeStoreRequest extends PaymentBraintreeStoreRequest {
  public recharge: boolean = true;
}
